import { render, staticRenderFns } from "./ProdutosFatorAtuacao.vue?vue&type=template&id=6cb92850&scoped=true"
import script from "./ProdutosFatorAtuacao.vue?vue&type=script&lang=js"
export * from "./ProdutosFatorAtuacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb92850",
  null
  
)

export default component.exports